import { ApiProperty } from "@nestjs/swagger";
import { budgetPeriodEnum } from "packages/libs/shared-models/src/common/vms/masters/budget/budget.enum";



export class BudgetDto {
    @ApiProperty()
    id: number;

    @ApiProperty()
    budgetPeriod: budgetPeriodEnum;

    @ApiProperty()
    fromDate:  Date|string;

    @ApiProperty()
    toDate: Date|string;

    @ApiProperty()
    budget: number;

    @ApiProperty()
    plantId: number;

    @ApiProperty()
    departmentName: number;

    @ApiProperty()
    createdUser: string | null;

    @ApiProperty()
    createdAt: Date;

    @ApiProperty()
    updatedUser: string | null;

    @ApiProperty()
    updatedAt: Date;

    @ApiProperty()
    isActive: boolean;

    @ApiProperty()
    versionFlag: number;
}